export const getChildren = (nodeEntry) => {
  const [node, path] = nodeEntry;
  const children = node.children || [];
  return children.map((child, index) => {
    const childPath = path.concat([index]);
    return [child, childPath];
  });
};
